
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/men/[...slug]",
      function () {
        return require("private-next-pages/men/[...slug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/men/[...slug]"])
      });
    }
  